import React from 'react';
import { Tag, Text, ThemeMode, useThemeMode } from '@amzn/storm-ui';
import { getBreadcrumbLabel } from './breadcrumbsHelper';
import type { Breadcrumb as BreadcrumbType } from '../../../../app/slice';

export const TextBreadcrumb = ({
  breadcrumb,
}: {
  breadcrumb: BreadcrumbType;
}) => {
  const { themeMode } = useThemeMode();

  return (
    <Text inline color={themeMode === ThemeMode.DARK ? 'default' : 'inverted'}>
      {getBreadcrumbLabel(breadcrumb)}
      {breadcrumb.objectSuffix && (
        <Tag variant="beta" label={breadcrumb.objectSuffix} />
      )}
    </Text>
  );
};
